<template>
  <div
    class="app-content content"
    :class="[{'show-overlay': $store.state.app.shallShowOverlay}, $route.meta.contentClass]"
  >
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper"
      :class="contentWidth === 'boxed' ? 'container p-0' : null">

      <b-alert v-if="!$store.state.auth.userData.expiration_state" variant="warning" show>
        <div class="alert-body">
          <feather-icon
              icon="InfoIcon"
              class="mr-50"
          />
          {{ $t('your account is about to expire')}}
        </div>
      </b-alert>

      <slot name="breadcrumb">
        <app-breadcrumb />
      </slot>

      <div class="content-body">
        <transition :name="routerTransition" mode="out-in">
          <slot />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import {BAlert} from 'bootstrap-vue'

export default {
  components: {
    AppBreadcrumb,
    BAlert
  },
  setup() {
    const { routerTransition, contentWidth } = useAppConfig()

    return {
      routerTransition, contentWidth,
    }
  },
}
</script>

<style>

</style>
